import { handleAPIError } from "@services/Base";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { MODEL_API_URL } from "../../../config";
import { ClientModelOutputData } from "../types";

export const useClientModelOutput = (model_id: string) => {
  return useQuery({
    queryKey: ["client", "model", "output", model_id],
    enabled: model_id.length > 0,
    queryFn: ({ signal }) =>
      axios
        .get(
          `${MODEL_API_URL}/waves-model-manager-api/v1/models/${model_id}/output`,
          {
            signal
          }
        )
        .then((response) => {
          return response.data as ClientModelOutputData;
        })
        .catch((error) => {
          return handleAPIError(error);
        })
  });
};
